'use client';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
export function JourneyShareButton({ href, label }: { href: string; label?: string }) {
  const t = useTranslations('Event.playerJourney');
  const [status, setStatus] = useState<'copied' | 'copyFailed' | null>(null);
  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <Button
        variant="outline"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(new URL(href, window.location.origin).href);
            setStatus('copied');
          } catch {
            setStatus('copyFailed');
          }
        }}
      >
        {label ?? t('share')}
      </Button>
      <span role="status" className="text-muted text-xs">
        {status ? t(status) : null}
      </span>
    </span>
  );
}
